<template>
  <div class="p-styleguide">
    <div class="container">
      <h2>Headings</h2>
      <br />
      <h1>H1 Heading</h1>
      <h2>H2 Heading</h2>
      <h3>H3 Heading</h3>
      <h4>H4 Heading</h4>
      <h5>H5 Heading</h5>
      <h6>H6 Heading</h6>
      <hr />
      <p>
        If you have one off revenue (up-sells, courses, or other products) then
        the net revenue could often be higher than its recurring counterpart.
        For ConvertKit the only factor making them materially different is
        annual plans (paying for a year up front in trade for a discount).
      </p>
      <p class="muted">This is muted text.</p>
      <a href="#">A link to somewhere</a>
      <br />
      <h2>Forms</h2>
      <label> Label </label>
      <b-dropdown id="dropdown-1" text="Dropdown Button" class="m-md-2">
        <b-dropdown-item>First Action</b-dropdown-item>
        <b-dropdown-item>Second Action</b-dropdown-item>
        <b-dropdown-item>Third Action</b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item active>Active action</b-dropdown-item>
        <b-dropdown-item disabled>Disabled action</b-dropdown-item>
      </b-dropdown>
      <br />
      <b-button variant="primary"> Primary </b-button><br />
      <b-button variant="secondary"> Secondary </b-button>
      <b-button variant="none"> Default </b-button>
      <br />
      <b-button variant="primary" size="sm"> Primary </b-button><br />
      <b-button variant="secondary" size="sm"> Secondary </b-button>
      <b-button size="sm"> Default </b-button>
      <div class="colors background">
        <span></span><span></span><span></span><span></span><span></span>
      </div>
      <div class="colors foreground">
        <span></span><span></span><span></span><span></span><span></span>
      </div>
      <div class="colors primary">
        <span></span><span></span><span></span><span></span><span></span>
      </div>
    </div>
  </div>
</template>

<script>
import microNotification from "@/components/micro-notification.vue";

export default {
  components: {
    microNotification,
  },
};
</script>

<style lang="scss">
.p-styleguide {
  padding: 1.5rem;

  .shortkey {
    display: inline-block;
    padding: 3px 10px;
    border-radius: 4px;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.225) 0%,
      rgba(255, 255, 255, 0.2) 33%,
      rgba(255, 255, 255, 0.15) 100%
    );
    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.2), 0 -1 0 rgba(0, 0, 0, 0.25);
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.5),
      0 -1px 2px 0 rgba(255, 255, 255, 0.1);
  }

  .contact {
    padding: 1rem;
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 7px;
    p {
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .colors {
    margin: var(--spacer-sm) 0;

    span {
      width: var(--spacer);
      height: var(--spacer);
      display: inline-block;
      margin-right: var(--spacer-sm);
      background-color: var(--g1);
      border-radius: 50%;

      &:nth-child(2) {
        background-color: var(--g2);
      }
      &:nth-child(3) {
        background-color: var(--g3);
      }
      &:nth-child(4) {
        background-color: var(--g4);
      }
      &:nth-child(5) {
        background-color: var(--g5);
      }
    }
    &.primary span {
      background-color: var(--p1);
      &:nth-child(2) {
        background-color: var(--p2);
      }
      &:nth-child(3) {
        background-color: var(--p3);
      }
      &:nth-child(4) {
        background-color: var(--p4);
      }
      &:nth-child(5) {
        background-color: var(--p5);
      }
    }
    &.foreground span {
      background-color: var(--w1);
      &:nth-child(2) {
        background-color: var(--w2);
      }
      &:nth-child(3) {
        background-color: var(--w3);
      }
      &:nth-child(4) {
        background-color: var(--w4);
      }
      &:nth-child(5) {
        background-color: var(--w5);
      }
    }
  }

  .infobox {
    position: relative;
    margin-bottom: 1rem;

    padding: 1rem;
    border-radius: 7px;
    background-color: var(--s3);
    box-shadow: 0 1.8px 3px rgba(0, 0, 0, 0.048),
      0 6px 10.1px rgba(0, 0, 0, 0.072), 0 27px 45px rgba(0, 0, 0, 0.12);

    &:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 7px;
      pointer-events: none;
      background: linear-gradient(
        356deg,
        rgba(255, 255, 255, 0.09) 0%,
        rgba(255, 255, 255, 0.15) 70%
      );
    }
  }

  ul {
    counter-reset: LIST-ITEMS 0;
    margin-bottom: 2rem;
    li {
      margin-top: 1rem;
      margin-bottom: 1.5rem;
      margin-left: 1.75rem;
      &:before {
        position: absolute;
        left: -1rem;
        top: calc(0.5rem - 1px);
        content: " ";
        height: 8px;
        width: 8px;
        border-radius: 50%;
        background-color: currentColor;
        position: absolute;
        pointer-events: none;
      }
      > h4 {
        line-height: 1.4;
        color: var(--p3);
        text-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
        padding-top: 0.3rem;
      }
      > span {
        display: initial;
        line-height: 1;
        font-size: 0.925rem;
        .keycap {
          color: black;
          font-weight: 500;
        }
      }
      > img {
        border-radius: 6px;
        width: calc(100% + 2.75rem);
        height: auto;
        margin-left: -2.75rem;
        margin-top: 1rem;
        margin-bottom: 0.5rem;
        display: block;
        box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.25);
      }
      &:before {
        top: 4px;
        left: -2.75rem;
        width: 32px;
        height: 32px;
        padding: 4px;
        text-align: center;
        content: counter(LIST-ITEMS);
        counter-increment: LIST-ITEMS;
        font-weight: 600;
        background-color: transparent;
        color: var(--p3);
        line-height: 1.25;
        border: var(--p3) solid 2px;
      }
    }
  }
}
</style>
